module.exports = __webpack_public_path__ + "images/emoji_1a5938cf0f2799264bb2eb9ae243a8189.svg";